// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Shipment } from '@/shipment/api/types';

/**
 * Every serial this shipment has already claimed, merged across all of its
 * lines: what shipped, what the third party has committed as pending, and what
 * it is still holding. None of them can be picked as a corrected serial — the
 * first two would ship the unit twice, and a held one is itself waiting on a
 * resolution.
 *
 * Held serials are deliberately absent from the lines, so merging the lines
 * alone would leave one hold pickable as another hold's correction.
 */
export function shipmentClaimedSerials(shipment: Shipment): string[] {
  const lineSerials = shipment.items.flatMap((item) => [
    ...item.serials,
    ...item.pendingSerials,
  ]);
  const heldSerials = shipment.quarantinedSerials
    .filter((held) => held.resolution === null)
    .map((held) => held.serial);

  return [...lineSerials, ...heldSerials];
}
